import React from "react";
import ReactDOM from "react-dom";
import { Route, Routes, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import AppContainer from "container/AppContainer";
import { ScoreReportType } from "goalsCard/store/ScoreReportType";
import { CardEnum } from "container/CardEnum";
import pages from "shared/routing/pages";
import { MotivationCardTab } from "motivationCard/MotivationCardTab";
import App from "App";
import AppInsights from "appilication-insights/ApplicationInsights";
import MsTeamsStore from "msTeams/store";
import { View360CardTab } from "view360Card/models";
import { QueryClient, QueryClientProvider } from "react-query";

export const history = createBrowserHistory({ window });

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const ReactQueryDevtoolsProduction = React.lazy(() =>
    import("react-query/devtools/development").then((d) => ({
        default: d.ReactQueryDevtools,
    }))
);

ReactDOM.render(
    <MsTeamsStore>
        <AppInsights>
            <QueryClientProvider client={queryClient}>
                <HistoryRouter history={history}>
                    <Routes>
                        <Route path="/" element={<App />}>
                            <Route path="/" element={<AppContainer firstLevelTab={undefined} />} />
                            <Route
                                path={pages.goalsMonthly.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.GoalsCard}
                                        secondLevelTab={ScoreReportType.MONTHLY}
                                    />
                                }
                            />
                            <Route
                                path={pages.goalsQuarterly.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.GoalsCard}
                                        secondLevelTab={ScoreReportType.QUARTERLY}
                                    />
                                }
                            />
                            <Route
                                path={pages.goalsMonthlyRms.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.GoalsCard}
                                        secondLevelTab={ScoreReportType.MONTHLY_RMS}
                                    />
                                }
                            />
                            <Route path={pages.tasks.path} element={<AppContainer firstLevelTab={CardEnum.Tasks} />} />
                            <Route
                                path={pages.motivationMonthly.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.MotivationCard}
                                        secondLevelTab={MotivationCardTab.SALESRANK_MONTHLY}
                                    />
                                }
                            />
                            <Route
                                path={pages.motivationQuarterly.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.MotivationCard}
                                        secondLevelTab={MotivationCardTab.SALESRANK_QUARTERLY}
                                    />
                                }
                            />
                            <Route
                                path={pages.powerBiReports.path}
                                element={<AppContainer firstLevelTab={CardEnum.PowerBiReports} />}
                            />
                            <Route
                                path={pages.globalNotes.path}
                                element={<AppContainer firstLevelTab={CardEnum.GlobalNotes} />}
                            />
                            <Route
                                path={pages.view360.path}
                                element={<AppContainer firstLevelTab={CardEnum.View360} secondLevelTab={undefined} />}
                            />
                            <Route
                                path={pages.view360GeneralInformationTabIntermediary.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.GENERAL_INFORMATION}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360EmployeesListIntermediary.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.EMPLOYEES}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360SalesTabIntermediary.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.SALES}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360NotesTabIntermediary.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.NOTES}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360GeneralInformationTabSalesPerson.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.GENERAL_INFORMATION}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360SalesTabSalesPerson.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.SALES}
                                    />
                                }
                            />
                            <Route
                                path={pages.view360NotesTabSalesPerson.path}
                                element={
                                    <AppContainer
                                        firstLevelTab={CardEnum.View360}
                                        secondLevelTab={View360CardTab.NOTES}
                                    />
                                }
                            />
                        </Route>
                    </Routes>
                </HistoryRouter>
                {process.env.REACT_APP_USE_DEV_TOOLS === "true" && (
                    <React.Suspense fallback={null}>
                        <ReactQueryDevtoolsProduction />
                    </React.Suspense>
                )}
            </QueryClientProvider>
        </AppInsights>
    </MsTeamsStore>,
    document.getElementById("root")
);
